import React, { useState, useEffect, useRef } from "react";
import {
  Typography,
  Box,
} from "@mui/material";
import { isMobile } from "react-device-detect";

const ContactFormComponent = () => {
  const [whatsappBottom, setWhatsappBottom] = useState(isMobile ? 20 : 40);
  const contactSectionRef = useRef(null);

  useEffect(() => {
    let ticking = false;
    
    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          if (contactSectionRef.current) {
            const contactRect = contactSectionRef.current.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            const threshold = isMobile ? 20 : 50; // Más sensible en móvil
            
            // Si la sección de contacto es visible
            if (contactRect.top <= windowHeight - threshold) {
              // Calculamos la nueva posición bottom basada en la posición de la sección
              const offset = isMobile ? 105 : 147;
              const newBottom = windowHeight - contactRect.top - offset;
              setWhatsappBottom(Math.max(newBottom, isMobile ? 20 : 40));
            } else {
              // Volvemos a la posición original
              setWhatsappBottom(isMobile ? 20 : 40);
            }
          }
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll(); // Ejecutar una vez al montar el componente

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      <Box
        ref={contactSectionRef}
        sx={{
          display: "flex",
          flexDirection: "column",
          margin: "auto",
          color: "#454545",
          textAlign: { xs: "left", md: "center" },
        }}
      >
        <Typography
          sx={{
            mb: 2,
            mt: { xs: 2, md: 4 },
            fontSize: { xs: "24px", md: "36px" },
            fontFamily: "Poppins-SemiBold",
            textAlign: "center",
            color: "#141414",
          }}
        >
          Respondemos tus dudas
        </Typography>
        
        <Typography
          sx={{
            mb: { xs: 4, md: 6 },
            fontFamily: "Quicksand-Regular",
            fontSize: isMobile ? "16px" : "20px",
            color: "#333333",
            // Animación para la manito
            '@keyframes wiggleHand': {
              '0%': {
                transform: 'translateX(0px)',
              },
              '50%': {
                transform: 'translateX(9px)',
              },
              '100%': {
                transform: 'translateX(0px)',
              },
            },
            '& .hand-emoji': {
              display: 'inline-block',
              animation: 'wiggleHand 2s ease-in-out infinite',
            },
          }}
        >
          {isMobile ? (
            <>
              Conversemos por WhatsApp{' '}
              <span className="hand-emoji">👉🏻</span>
            </>
          ) : (
            <>
              Escribenos y conversemos por WhatsApp{' '}
              <span className="hand-emoji">👉🏻</span>
            </>
          )}
        </Typography>
      </Box>

      {/* Círculo verde flotante - SIEMPRE fixed para mantener posición X */}
      <Box
        component="a"
        href="https://api.whatsapp.com/send/?phone=%2B56920809101&text=Hola,%20amigos%20de%20Clinifica.%20Tengo%20una%20duda,%20%C2%BFpodr%C3%ADan%20ayudarme?&type=phone_number&app_absent=0"
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          position: "fixed", // SIEMPRE fixed para que la posición X no cambie nunca
          bottom: `${whatsappBottom}px`, // Solo cambia la posición Y
          right: isMobile ? "20px" : "30px", // Posición X SIEMPRE la misma
          width: isMobile ? "50px" : "60px",
          height: isMobile ? "50px" : "60px",
          backgroundColor: "#25D366", // Color oficial de WhatsApp
          borderRadius: "50%",
          cursor: "pointer",
          zIndex: 1000,
          boxShadow: "0 4px 16px rgba(37, 211, 102, 0.4)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transition: isMobile ? "all 0.15s ease-out" : "all 0.3s ease", // Mucho más rápido en móvil
          textDecoration: "none",
          "&:hover": {
            transform: "scale(1.1)",
            boxShadow: "0 6px 20px rgba(37, 211, 102, 0.6)",
            backgroundColor: "#20c157",
          }
        }}
      >
        {/* Ícono de WhatsApp */}
        <Box
          sx={{
            fontSize: isMobile ? "24px" : "28px",
            color: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
            <img
                        src="/whatsapp.svg"
                        alt="whatsapp"
                        style={{
                          width: isMobile ? "20px" : "27px",
                        }}
                      />
        </Box>
      </Box>
    </>
  );
};

export default ContactFormComponent;
